const symphonyRoute = process.env.REACT_APP_SYMPHONY_BASE_URL

export const routeProvider = {
  recommendation: `${symphonyRoute}/recomendacion`,
  recomendationForm: `${symphonyRoute}/recomendacion?`,
  recommendationStepForm: `/recomendacion-cuidador`,
  residenceForm: `/formulario-residencias`,
  manualResidenceForm: (caretakerId: string) => `/formulario-residencias/${caretakerId}`,
  childRecommendationStepForm: `/formulario-kids`,
  recruitingForm: `/formulario-seleccion`,
  confirmRecruitingForm: `/solicitud-seleccion-enviada`,
  resumeStep: `/solicitud-enviada`,
  residenceFormConfirmation: `/solicitud-enviada-residencia`,
  childResumeStep: `/solicitud-enviada-kids`,
  manualResumeStep: `/solicitud-enviada-cuidador`,
  caretakerRecommendation: serviceId => `/recomendacion-cuidador/${serviceId}`,
  broadcastForm: `/busqueda-abierta`,
  broadcastFormConfirmation: `/solicitud-enviada-busqueda-abierta`,
  checkout: (caretakerId: string, requestId: string, props: string) => `/checkout/${caretakerId}/${requestId}?${props}`,
  leadForm: (requestId: string, props?: string) => `/recoger-lead/${requestId}?${props}`,
  leadFormConfirmation: (serviceId: string, isBroadcast: string) =>
    `/recoger-lead/confirmacion?serviceId=${serviceId}&isBroadcast=${isBroadcast}`,
  longTermCaretakerRecommendation: serviceId => `/recomendacion-largo-plazo/${serviceId}`,
  checkoutForm: (caretakerId: string, requestId: string) =>
    `/formulario-checkout/${caretakerId}?requestId=${requestId}`,
  confirmPayment: `/reserva-confirmada`,
  customerPremium: `/premium`,
  customerPremiumPayment: planSelected => `/premium/plan/${planSelected}`,
  customerPremiumConfirmation: `/premium/confirmacion`,
  caretakerPro: `/pro`,
  caretakerProPayment: planSelected => `/pro/plan/${planSelected}`,
  caretakerProConfirmation: `/pro/confirmacion`,
  registerLoginPremium: `/premium/registro-login`,
  reservationConfirm: requestId => `/confirmar-reserva/${requestId}`,
  checkoutPayment: (caretakerId, requestId) => `/confirmar-reserva-checkout/${caretakerId}?requestId=${requestId}`,
  oldCaretakerRequest: caretakerId => `${symphonyRoute}/solicitud/servicio/${caretakerId}`,
  caretakerRequest: caretakerId => `/solicitud/${caretakerId}`,
  caretakerConfirm: requestId => `${symphonyRoute}/servicio/${requestId}/confirm?confirm=1`,
  newCustomerReview: (requestId, caretakerId) =>
    `/servicio/${requestId}/valoracion-a-cuidador?caretakerId=${caretakerId}`,
  newCaretakerReview: requestId => `/servicio/${requestId}/valoracion-a-cliente`,
  caretakerExternalReview: userId => `/usuario/${userId}/valoracion-a-cuidador`,
  clientProfile: `${symphonyRoute}/mi-perfil`,
  mainPage: `/`,
  deepLinkHome: `${process.env.REACT_APP_BASE_URL_DEEP_LINK as string}/mis-servicios`,
  caretakerCard: caretakerId => `/cuidadores/${caretakerId}`,
  register: `/registro`,
  registerCaretakerOnboardign: `registro/cuidador/onboarding`,
  registerCustomerOnboardign: `registro/cliente/onboarding`,
  caretakerRegistration: `/cuidador/registro`,
  customerRegistration: `/cliente/registro`,
  login: `/login`,
  caretakerList: `/cuidadores`,
  myServices: `/mis-servicios#solicitudes`,
  myBookedServices: `/mis-servicios#reservas`,
  myHistoricalServices: `/mis-servicios#historico`,
  myProfessionalRecruitingService: `/mis-servicios/seleccion-profesionales`,
  myProfessionalRecruitingHistoricalService: `/mis-servicios/seleccion-profesionales#historico`,
  residentsList: `/mis-servicios/listado-residentes`,
  newResident: `${symphonyRoute}/representante/representado/new`,
  editResident: (residentId: string) => `${symphonyRoute}/representante/representado/${residentId}/edit`,
  imagesReviews: `/mis-servicios/revision-imagenes`,
  professionalSelectionConfirm: requestId => `/confirmacion-seleccion/${requestId}`,
  myUserArea: `/mi-area-privada`,
  fullMap: `/mapa-clientes`,
  chat: `/chat`,
  chatConversation: userId => `/chat/${userId}`,
  chatGroupConversation: groupId => `/chat/grupo/${groupId}`,
  clientMyServices: `${symphonyRoute}/mis-transacciones`,
  myRecruitingService: `${symphonyRoute}/seleccion-profesionales`,
  nursingHomeResident: `${symphonyRoute}/representante/representado`,
  nursingHomeManager: `${symphonyRoute}/representantes/colaboradores`,
  profile: `/profile`,
  offersForCaretaker: `/ofertas`,
  introductionMessage: serviceId => `/mis-servicios/presentacion/${serviceId}`,
  caretakerServiceDetails: serviceId => `/mis-servicios/solicitudes/${serviceId}`,
  customerRequestDetails: serviceId => `/mis-servicios/servicios/${serviceId}`,
  customerLongTermRequestDetails: serviceId => `/mis-servicios/particular-largo-plazo/${serviceId}`,
  recommendationType: `/tipo-recomendacion`,
  services: `/profile/mis-servicios`,
  personalData: `/profile/datos-personales`,
  identityVerification: `/profile/verificacion-identidad`,
  identityVerificationProcess: `/profile/verificacion-identidad/proceso`,
  professionalData: `/profile/acreditacion`,
  bankData: `/profile/datos-pago`,
  settings: `/profile/ajustes`,
  changePassword: `/profile/ajustes/cambiar-contrasena`,
  deactivate: `/profile/ajustes/desactivar-perfil`,
  myPremiumPlan: `/profile/ajustes/mi-plan-premium`,
  myProPlan: `/profile/ajustes/mi-plan-pro`,
  cancelProPlan: `/profile/ajustes/mi-plan-pro/cancelacion`,
  confirmCancelProPlan: `/profile/ajustes/mi-plan-pro/cancelacion/confirmacion`,
  updatePaymentPro: `/profile/ajustes/mi-plan-pro/actualizacion-pago`,
  resetPassword: `/restablecer/contrasena`,
  blog: process.env.REACT_APP_BLOG,
  contractPacketBasicInfo: `https://ayuda.familiados.com/familias/pack-asesoramiento-basic/`,
  contractPacketCompletto3Info: `https://ayuda.familiados.com/familias/pack-asesoramiento-completto-3/`,
  contractPacketCompletto12Info: `https://ayuda.familiados.com/familias/pack-asesoramiento-completto-12/`,
  help: `https://ayuda.familiados.com/`,
  nursingHomeHelp: `https://ayuda.familiados.com/centros-sociosanitarios/`,
  contractAdvantagesAndInsurances: `https://ayuda.familiados.com/familias/ventajas-y-seguros`,
  qualificationsHelp: `https://ayuda.familiados.com/cuidadores/perfil-profesional/niveles-profesionales/`,
  howToTakePhoto: `https://ayuda.familiados.com/cuidadores/perfil-profesional/consejos-para-foto-de-perfil/`,
  activeMyAccount: `https://ayuda.familiados.com/cuidadores/perfil-profesional/activar-mi-cuenta-con-neocheck/`,
  howCaretakerFilters: `https://ayuda.familiados.com/familias/buscar-profesionales-en-familiados/como-filtramos-a-los-profesionales/`,
  adults: `https://senior.familiados.com/`,
  kids: `https://kids.familiados.com/`,
  sanintaryCenters: `https://centros.familiados.com/`,
  pharmacies: `https://farmacias.familiados.com/`,
  business: `https://empresas.familiados.com/`,
  prosAdults: `https://cuidadores.familiados.com/trabajos-cuidadora-mayores`,
  prosKids: `https://cuidadores.familiados.com/trabajos-cuidadora-ninos`,
  sickPeople: `https://cuidar.familiados.com/cuidadores-de-enfermos/`,
  hospitalCare: `https://blog.familiados.com/cuidado-hospital/`,
  alzheimer: `https://cuidar.familiados.com/cuidadores-de-alzheimer/`,
  contact: `mailto:contacto@familiados.com`,
  soporte: `mailto:soporte@familiados.com`,
  civilInsurance: `https://ayuda.familiados.com/seguros/seguro-responsabilidad-civil/`,
  accidentInsurance: `https://ayuda.familiados.com/seguros/seguro-accidentes/`,
  insuranceInfo: `https://ayuda.familiados.com/seguros/`,
  verificationProcess: `https://ayuda.familiados.com/familias/buscar-cuidadoras-en-familiados/como-filtramos-a-las-cuidadoras/`,
  shareOnEmail: (subject, shareLanding) => `mailto:?subject=${subject}&body=${shareLanding}`,
  shareOnWhatsapp: shareLanding => `https://api.whatsapp.com/send?text=${shareLanding}`,
  privacyPolicy: `/politica-privacidad`,
  termsOfService: '/condiciones-generales',
  cookies: `/cookies`,
  facebook: `https://www.facebook.com/familiadosayudaparacuidar`,
  youtube: `https://www.youtube.com/channel/UC2hmySKyXVPXhO0ey9Mo0Zw`,
  playStoreApp: `https://play.google.com/store/apps/details?id=com.familiados.app&referrer=utm_source%3Dhome%26utm_medium%3Dweb%26utm_campaign%3Dfooter`,
  iosAppStore: `https://apps.apple.com/app/apple-store/id1526160430?pt=121704022&ct=web_home_footer&mt=8`,
  instagram: `https://www.instagram.com/familiados.st/`,
  stripe: `https://stripe.com/`,
  stripeAccountAggreement: `https://stripe.com/connect/account-terms`,
  confianzaOnline: `https://www.confianzaonline.es/`,
  confianzaOnlineCustomers: `https://www.confianzaonline.es/como-reclamar/formulario-de-reclamaciones/`,
  onlineDisputeResolutionOfEU: `https://ec.europa.eu/consumers/odr/main/?event=main.home2.show`,
  notFount: `${symphonyRoute}/404`,
  confirmServicesDuration: '/confirmacion-duracion-servicio',
  timeExpired: '/servicio-tiempo-expirado',
  howItsWorkCaretaker: `${symphonyRoute}/como-funciona/soy-cuidador`,
  howItsWorkSearchCaretaker: `${symphonyRoute}/como-funciona/busco-cuidador`,
  advantagesCaretaker: `${symphonyRoute}/ventajas/soy-cuidador`,
  advantagesSearchCaretaker: `${symphonyRoute}/ventajas/busco-cuidador`,
  contactPage: `${symphonyRoute}/contacto`,
  residenceReportForm: `https://docs.google.com/forms/d/e/1FAIpQLSdi2SVEhiziK7YcTQ9ZLO7xchkJ4Y4s78YefzZz6C6mt1lO6g/viewform?usp=sf_link`,
}



// WEBPACK FOOTER //
// ./src/utils/routeProvider.ts